import React from 'react';
import { flushSync } from 'react-dom';
import { useSelector } from 'react-redux';
import claimProjectReportsListsService from '../services/lists/claim_groups/claim_project_reports_lists.service';
import ModelInstanceSelector from '../dashboards/components/ModelInstanceSelector';
import { buildQueryString } from '../services/service';

/**
 * 
 * @param {Object} queryParams - key-value pairs. Each key is passed as a query parameter. You can also pass a 'query' key which is an object. Each key-value pair is used to build a query string.
 *    The search project name is attached to that query string.
 *    E.g.: { group_projects: false, query: code: '123' } => { group_projects: false, query: "projec_name=SomeProject&code=123" }
 *    This object is then passed to the service.
 *                  
 * @returns 
 */
export const ProjectSelector = _ref => {
  let {
    claimGroupId,
    className = '',
    alreadySelectedInstances = [],
    excludeAlreadySelectedInstances = false,
    onChange,
    onBlur,
    onSelectInstance,
    eventFieldName,
    queryParams = {},
    searchInputRef
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const [reports, setReports, totalPages, setTotalPages, params, setParams, fetchAllProjetcs] = claimProjectReportsListsService.useFetchAll({
    accountType: user.account_type,
    claimGroupId,
    groupProjects: false,
    fetchImmediatelly: false
  });
  const alreadySelectedInstanceIds = new Set(alreadySelectedInstances.map(instance => instance?.id).filter(id => id !== undefined && id !== null));
  const fetchProjectsByName = async projectName => {
    const fullQueryString = buildQueryString({
      ...(queryParams.query || {}),
      project_name: projectName
    });
    const filteredProjects = await fetchAllProjetcs({
      ...queryParams,
      query: fullQueryString
    });
    return {
      values: excludeAlreadySelectedInstances ? filteredProjects.claim_project_reports.filter(project => !alreadySelectedInstanceIds.has(project.id)) : filteredProjects.claim_project_reports,
      totalPages: filteredProjects.pages
    };
  };
  const buildEventLikeObject = value => {
    return {
      target: {
        type: 'select',
        value,
        name: eventFieldName
      },
      preventDefault: () => {},
      stopPropagation: () => {},
      stopImmediatePropagation: () => {}
    };
  };
  return /*#__PURE__*/React.createElement(ModelInstanceSelector, {
    className: className,
    allowMultipleSelection: false,
    selectInstances: async project => {
      const event = buildEventLikeObject(project.id);
      flushSync(() => {
        onChange(event);
      });
      onBlur(event);
      onSelectInstance && onSelectInstance(project);
    },
    onSearch: fetchProjectsByName,
    alreadySelectedInstances: alreadySelectedInstances,
    displayTextKey: 'project_name',
    searchInputRef: searchInputRef
  });
};